module.exports = __webpack_public_path__ + "static/media/reportsSvg.2d7a621a.svg";